import { render, staticRenderFns } from "./wordsList.vue?vue&type=template&id=0777a30b&scoped=true&"
import script from "./wordsList.vue?vue&type=script&lang=js&"
export * from "./wordsList.vue?vue&type=script&lang=js&"
import style0 from "./wordsList.vue?vue&type=style&index=0&id=0777a30b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0777a30b",
  null
  
)

export default component.exports